import { http } from '@/lib/ats-https';

export interface CBVJobSettings {
  ats_job_id: number;
  contact_background_verification_integration_enabled: boolean;
  contact_background_verification_auto_verification_enabled: boolean;
  contact_background_verification_auto_reject_ats_form_template_id:
    | number
    | null;
  contact_background_verification_auto_reject_survey_form_template_id:
    | number
    | null;
  contact_background_verification_auto_reject_rule_id: number | null;
  contact_background_verification_auto_reject_ats_rejection_reason_id:
    | number
    | null;
  contact_background_verification_auto_reject_enabled: boolean;
  contact_background_verification_auto_reject_send_email: boolean;
  contact_background_verification_auto_reject_ats_comm_template_id:
    | number
    | null;
  contact_background_verification_auto_reject_email_subject: string | null;
  contact_background_verification_auto_reject_email_body: string | null;
  contact_background_verification_auto_reject_email_sender_id: number | null;
  contact_background_verification_auto_reject_schedule: boolean;
  contact_background_verification_auto_reject_send_after: number | null;
  contact_background_verification_auto_reject_scheduled_at: string | null;
  contact_background_verification_auto_reject_scheduled_at_timezone:
    | string
    | null;
  contact_background_verification_auto_reject_ats_shared_email_id:
    | number
    | null;
  contact_background_verification_auto_reject_cc: string[];
  contact_background_verification_auto_reject_bcc: string[];
  contact_background_verification_auto_reject_email_attachments: unknown[];
  errors: unknown[];
}

interface CBVJobSettingsResponse {
  data: CBVJobSettings;
  errors: unknown[];
}

export const FRAUD_DETECTOR_JOB_API = {
  getJobSettings: async (
    jobId: string | number
  ): Promise<CBVJobSettings | null> => {
    try {
      const res = (await http.get(
        `/contact_background_verification/job_template_settings?ats_job_id=${jobId}`
      )) as CBVJobSettingsResponse;
      return res?.data ?? null;
    } catch {
      return null;
    }
  },

  saveJobSettings: async (
    payload: Partial<CBVJobSettings>
  ): Promise<CBVJobSettings | null> => {
    const res = (await http.put(
      '/contact_background_verification/job_template_settings',
      payload
    )) as CBVJobSettingsResponse;
    if ((res?.errors as unknown[])?.length > 0) {
      throw res;
    }
    return res?.data ?? null;
  },
};
